/*
 angular-tablesort v1.0.0
 (c) 2013 Mattias Holmlund, http://mattiash.github.io/angular-tablesort
 License: MIT
*/

var tableSortModule = angular.module("tableSort", []);

tableSortModule.directive("tsWrapper", function ($log, $parse) {
    "use strict";
    return {
        scope: true,
        controller: function ($scope) {
            $scope.sortExpression = [];
            $scope.headings = [];
            $scope.sortBy = "";

            this.getSortExpression = function () {
                return $scope.sortExpression[0][2];
            };

            var parse_sortexpr = function (expr) {
                return [$parse(expr), null, false];
            };

            this.setSortField = function (sortexpr, element) {
                var i;
                var expr = parse_sortexpr(sortexpr);
                $scope.sortBy = sortexpr;
                if ($scope.sortExpression.length === 1 && $scope.sortExpression[0][0] === expr[0]) {
                    if ($scope.sortExpression[0][2]) {
                        element.removeClass("tablesort-desc");
                        element.addClass("tablesort-asc");
                        $scope.sortExpression[0][2] = false;
                    } else {
                        element.removeClass("tablesort-asc");
                        element.addClass("tablesort-desc");
                        $scope.sortExpression[0][2] = true;
                    }
                } else {
                    for (i = 0; i < $scope.headings.length; i = i + 1) {
                        $scope.headings[i].removeClass("tablesort-desc").removeClass("tablesort-asc");
                    }
                    element.addClass("tablesort-asc");
                    $scope.sortExpression = [expr];
                }
            };

            this.addSortField = function (sortexpr, element) {
                var i;
                var toggle_order = false;
                var expr = parse_sortexpr(sortexpr);
                for (i = 0; i < $scope.sortExpression.length; i = i + 1) {
                    if ($scope.sortExpression[i][0] === expr[0]) {
                        if ($scope.sortExpression[i][2]) {
                            element.removeClass("tablesort-desc");
                            element.addClass("tablesort-asc");
                            $scope.sortExpression[i][2] = false;
                        } else {
                            element.removeClass("tablesort-asc");
                            element.addClass("tablesort-desc");
                            $scope.sortExpression[i][2] = true;
                        }
                        toggle_order = true;
                    }
                }
                if (!toggle_order) {
                    element.addClass("tablesort-asc");
                    $scope.sortExpression.push(expr);
                }
            };

            this.registerHeading = function (headingelement) {
                $scope.headings.push(headingelement);
            };

            $scope.sortFun = function (a, b) {
                var i, aval, bval, descending, filterFun;

                for (i = 0; i < $scope.sortExpression.length; i = i + 1) {
                    aval = $scope.sortExpression[i][0](a);
                    bval = $scope.sortExpression[i][0](b);

                    filterFun = b[$scope.sortExpression[i][1]];

                    if (filterFun) {
                        aval = filterFun(aval);
                        bval = filterFun(bval);
                    }
                    if (!aval) {
                        aval = "";
                    }
                    if (!bval) {
                        bval = "";
                    }
                    descending = $scope.sortExpression[i][2];

                    // Sorting for bannersizes - width x height
                    if (
                        aval &&
                        typeof aval === "object" &&
                        aval.hasOwnProperty("width") &&
                        aval.hasOwnProperty("height")
                    ) {
                        var aWidth = aval.width,
                            aHeight = aval.height,
                            bWidth = bval.width,
                            bHeight = bval.height;
                        if (aWidth === bWidth && aHeight > bHeight) {
                            return descending ? -1 : 1;
                        } else if (aWidth === bWidth && aHeight < bHeight) {
                            return descending ? 1 : -1;
                        } else if (aWidth > bWidth) {
                            return descending ? -1 : 1;
                        } else if (aWidth < bWidth) {
                            return descending ? 1 : -1;
                        }
                    }
                    if (aval && aval.hasOwnProperty("name")) {
                        var aName = aval.name,
                            aCultureName = aval.cultureName,
                            bName = bval.name,
                            bCultureName = bval.cultureName;

                        if (aName === bName && aCultureName > bCultureName) {
                            return descending ? -1 : 1;
                        } else if (aName === bName && aCultureName < bCultureName) {
                            return descending ? 1 : -1;
                        } else if (aName > bName) {
                            return descending ? -1 : 1;
                        } else if (aName < bName) {
                            return descending ? 1 : -1;
                        }
                    }

                    if (aval > bval) {
                        return descending ? -1 : 1;
                    } else if (aval < bval) {
                        return descending ? 1 : -1;
                    }
                }
                return 0;
            };
        }
    };
});

tableSortModule.directive("tsCriteria", function () {
    return {
        require: "^tsWrapper",
        scope: {
            callback: "&?callback"
        },
        link: function (scope, element, attrs, tsWrapperCtrl) {
            var clickingCallback = function (event) {
                scope.$apply(function () {
                    //if (event.shiftKey) {
                    //    tsWrapperCtrl.addSortField(attrs.tsCriteria, element);
                    //}
                    //else {
                    tsWrapperCtrl.setSortField(attrs.tsCriteria, element);
                    //}
                    if (scope.callback)
                        scope.callback({
                            field: attrs.tsCriteria,
                            asc: !tsWrapperCtrl.getSortExpression()
                        });
                });
            };
            element.bind("click", clickingCallback);
            element.addClass("tablesort-sortable");
            if ("tsDefault" in attrs && attrs.tsDefault !== "0") {
                tsWrapperCtrl.addSortField(attrs.tsCriteria, element);
                if (attrs.tsDefault == "descending") {
                    tsWrapperCtrl.addSortField(attrs.tsCriteria, element);
                }
            }
            tsWrapperCtrl.registerHeading(element);
        }
    };
});

tableSortModule.directive("tsRepeat", function () {
    return {
        require: "^tsWrapper",
        priority: 2000,
        compile: function (tElement, tAttrs, transclude) {
            tAttrs.ngRepeat += " | tablesortOrderBy:sortFun";
        }
    };
});

tableSortModule.filter("tablesortOrderBy", function () {
    return function (array, sortfun) {
        if (!array) return;
        var arrayCopy = [];
        for (var i = 0; i < array.length; i++) {
            arrayCopy.push(array[i]);
        }
        return arrayCopy.sort(sortfun);
    };
});

tableSortModule.filter("parseInt", function () {
    return function (input) {
        return parseInt(input);
    };
});

tableSortModule.filter("parseFloat", function () {
    return function (input) {
        return parseFloat(input);
    };
});
